import { Component, EventEmitter, Injector, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { DataStateChangeEvent, GridComponent, RowClassArgs } from '@progress/kendo-angular-grid';
import { finalize } from 'rxjs/operators';
import { CommonService } from 'src/app-core/services/common.service';
import { CustomerDataModel } from 'src/app/customer/customer-data-model';
import { CustomerService } from 'src/app/customer/customer.service';
import { AppComponentBase } from 'src/app/shared/app-component-base';
import { CommonDataModel } from '../common-data-model';

@Component({
  selector: 'app-customer-job-list',
  templateUrl: './customer-job-list.component.html',
  styleUrls: ['./customer-job-list.component.scss'],
  encapsulation: ViewEncapsulation.None,
})

export class CustomerJobListComponent extends AppComponentBase implements OnInit {

  @ViewChild('grid', { static: true }) private grid: GridComponent;

  @Output() emitCustomerJob: EventEmitter<any> = new EventEmitter<any>();

  @Input() accountId: any;
  @Input() gridName: any;
  @Input() accountLongId: any;

  account = new CustomerDataModel();
  commonDataModel = new CommonDataModel();
  jobsPermission = this.commonDataModel.jobsPermissionModel;
  quotesPermission = this.commonDataModel.quotesPermissionModel;
  searchQuery: string;
  filters: any;
  exportType: string;
  ordersCount: any;
  tenantId = this.commonService.getTenentId();
  franchiseId: any;
  statusValue = 'true';

  constructor(
    injector: Injector,
    private router: Router,
    private commonService: CommonService,
    private customerService: CustomerService) {
    super(injector);
    this.jobsPermission = this.commonService.permissionChecker(this.jobsPermission);
    this.quotesPermission = this.commonService.permissionChecker(this.quotesPermission);
  }

  ngOnInit() {
    const fId = localStorage.getItem('oidcCNFFranchaiseId');
    this.franchiseId = fId ? (+fId) : null;
    this.onRefreshGridData();
  }

  onRefreshGridData(): void {
    this.kendogridHelper.sort = [{ dir: 'desc', field: 'quoteId' }];
    this.grid.dataStateChange.emit({
      skip: 0,
      take: this.kendogridHelper.defaultRecordsCountPerPage,
      filter: undefined,
      group: undefined,
      sort: this.kendogridHelper.sort,
    });
  }

  getGridRecords(event: DataStateChangeEvent): void {
    if (event) {
      this.kendogridHelper.dataStateChangeEvent(event);
    }
    const queryParams = `&AccountId=${this.accountLongId}&GridName=${this.gridName}`;
    this.kendogridHelper.showLoadingIndicator();
    const gridStatus = `&IsActive= ${this.statusValue}`;
    this.customerService.getAccountOrdersGridRecords(event, queryParams, gridStatus)
      .pipe(finalize(() => (this.kendogridHelper.hideLoadingIndicator()))).subscribe(response => {
        this.kendogridHelper.setGridData(response.data);
        this.ordersCount = response.data.totalResults;
        this.emitCustomerJob.emit();
        this.kendogridHelper.hideLoadingIndicator();
      });
  }

  onCreateNewJob() {
    this.router.navigate([]).then(result => { window.open(`app/jobs/job-form?accountId=${this.accountId}`, '_blank'); });
  }

  onCreateNewQuote() {
    this.router.navigate([]).then(result => { window.open(`app/quotes/quote-form?accountId=${this.accountId}`, '_blank'); });
  }

  getJobOrQuoteLink(data: any): string {
      if (this.jobsPermission.ViewJobs) {
          return data.isJob
              ? `app/jobs/job-details?jobId=${data.orderId}`
              : `app/quotes/quote-details?quoteId=${data.orderId}`;
      }
      return '#'; // or use 'javascript:void(0);' if you need it to be non-clickable without permission
  }

  onToggleChange(value: string) {
    this.statusValue = value;
    this.onRefreshGridData();
  }

    rowCallback(context: RowClassArgs) {
        return {
            'rush-order': context.dataItem.isRush && !context.dataItem.isFinalized,
            'finalized-order': context.dataItem.isFinalized
        }
    }

}
